export default __webpack_public_path__ + "bml-characteristic3.20a305a.png";